// extracted by css-extract-rspack-plugin
export default {"root":"root-U9Oepf","body":"body-ftF7Yl","main":"main-fJlJC0","column":"column-rPrJk4"};